export default "__VITE_ASSET__Lyx1myGq__"